import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const OPERATING_KPI_COMPANY_VIEWS = {
  FINANCIAL_OVERVIEW: 'financial-overview',
  DASHBOARD: 'financial-overview',
  TRAJECTORY: 'trajectory',
  MARGINS: 'margins',
};

export const OPERATING_KPI_ROUTE_VIEW_TO_RENDER_VIEW = {
  [OPERATING_KPI_COMPANY_VIEWS.DASHBOARD]: 'graph',
  [OPERATING_KPI_COMPANY_VIEWS.TRAJECTORY]: 'accel',
  [OPERATING_KPI_COMPANY_VIEWS.MARGINS]: 'margins',
};

export const OPERATING_KPI_LEGACY_VIEW_TO_ROUTE_VIEW = {
  graph: OPERATING_KPI_COMPANY_VIEWS.DASHBOARD,
  dashboard: OPERATING_KPI_COMPANY_VIEWS.DASHBOARD,
  accel: OPERATING_KPI_COMPANY_VIEWS.TRAJECTORY,
  trajectory: OPERATING_KPI_COMPANY_VIEWS.TRAJECTORY,
  margins: OPERATING_KPI_COMPANY_VIEWS.MARGINS,
  table: OPERATING_KPI_COMPANY_VIEWS.DASHBOARD,
  model: OPERATING_KPI_COMPANY_VIEWS.DASHBOARD,
};

export const OPERATING_KPI_FINANCIAL_CHART_SKELETON = {
  kind: 'chart',
  preset: 'trendLine',
  variant: 'line',
  height: '35vh',
  width: '75%',
  minHeight: 300,
};

export const OPERATING_KPI_FINANCIAL_TABLE_SKELETON = {
  kind: 'table',
  preset: 'compsheet',
  rows: 20,
  columns: 8,
  tableWidth: '72%',
  height: 600,
};

const COMPANY_VIEW_METADATA = {
  [OPERATING_KPI_COMPANY_VIEWS.DASHBOARD]: {
    label: 'Financial Overview',
    title: 'Company Financial Overview',
    description: 'Company operating performance and valuation overview',
    icon: AccountBalanceIcon,
    layout: 'dashboardPanel',
    viewLayout: 'dashboardPanel',
    controls: [
      'companySearch',
      'metric',
      'reportingTimeframe',
      'period',
      'chartGrain',
      'chartCalculation',
      'chartType',
      'displayOptions',
    ],
    panels: [
      {
        id: 'companyFinancialSummary',
        kind: 'kpiStrip',
        skeleton: {
          kind: 'chart',
          preset: 'barTrend',
          variant: 'bar',
          height: 82,
          minHeight: 82,
          width: '100%',
        },
      },
      {
        id: 'companyFinancialTrend',
        kind: 'chart',
        skeleton: OPERATING_KPI_FINANCIAL_CHART_SKELETON,
      },
      {
        id: 'companyValuationSnapshot',
        kind: 'table',
        skeleton: {
          kind: 'table',
          preset: 'compactSignal',
          rows: 6,
          columns: 2,
          height: 240,
          tableWidth: '100%',
        },
      },
      { id: 'companyFinancialModel', kind: 'table', skeleton: OPERATING_KPI_FINANCIAL_TABLE_SKELETON },
    ],
    visualizations: ['kpiStrip', 'groupedBar', 'trendLine', 'table'],
    tableColumns: ['period', 'revenue', 'growth', 'margin', 'metricValue'],
  },
  [OPERATING_KPI_COMPANY_VIEWS.TRAJECTORY]: {
    navigationVisible: false,
    label: 'Trajectory',
    title: 'Company Growth Trajectory',
    description: 'Growth trajectory',
    icon: TrendingUpIcon,
    layout: 'chartTable',
    viewLayout: 'dashboardPanel',
    controls: ['companySearch', 'period', 'metric', 'sbcMode'],
    panels: [
      {
        id: 'companyTrajectory',
        kind: 'chart',
        skeleton: OPERATING_KPI_FINANCIAL_CHART_SKELETON,
      },
    ],
    visualizations: ['lineChart', 'table'],
    tableColumns: ['period', 'growth', 'acceleration', 'metricValue'],
  },
  [OPERATING_KPI_COMPANY_VIEWS.MARGINS]: {
    navigationVisible: false,
    label: 'Margins',
    title: 'Company Profitability & Margins',
    description: 'Profitability and margins',
    icon: AssessmentIcon,
    layout: 'chartTable',
    viewLayout: 'dashboardPanel',
    controls: ['companySearch', 'period', 'metric', 'sbcMode'],
    panels: [
      {
        id: 'companyMargins',
        kind: 'chart',
        skeleton: OPERATING_KPI_FINANCIAL_CHART_SKELETON,
      },
    ],
    visualizations: ['waterfall', 'table'],
    tableColumns: ['period', 'grossMargin', 'operatingMargin', 'freeCashFlowMargin'],
  },
};

export const OPERATING_KPI_COMPANY_VIEW_IDS = [...new Set(Object.values(OPERATING_KPI_COMPANY_VIEWS))];

export const getOperatingKpiCompanyViewMetadata = (viewId) => (
  COMPANY_VIEW_METADATA[viewId] || COMPANY_VIEW_METADATA[OPERATING_KPI_COMPANY_VIEWS.DASHBOARD]
);

export const getOperatingKpiCompanyViewDescriptors = () => (
  OPERATING_KPI_COMPANY_VIEW_IDS.map((id) => ({
    id,
    requiredData: 'financials',
    ...getOperatingKpiCompanyViewMetadata(id),
  }))
);
